import { Component } from '@angular/core';
import { VendorsModule } from '@my-aon/vendors';

@Component({
    selector: 'app-scroll-view',
    templateUrl: './scroll-view.component.html',
    styleUrl: './scroll-view.component.scss',
    imports: [
        VendorsModule
    ],
})
export class ScrollViewComponent {

}
